import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none",
  viewBox: "0 0 21 21"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5.415a1.56 1.56 0 0 0-1.41.894L6.707 6.117l-.018.035-.008.002-.027.004-5.243.777a1.56 1.56 0 0 0-.926 2.681l3.838 3.704.009.008a.05.05 0 0 1 .014.04l-.001.006-.915 5.352v.002a1.575 1.575 0 0 0 2.29 1.66h.001l4.724-2.498a.14.14 0 0 1 .108 0l4.724 2.497a1.573 1.573 0 0 0 2.198-.798c.111-.273.143-.571.093-.861v-.002l-.915-5.352v-.027l.013-.02v.001l.009-.008 3.838-3.704a1.56 1.56 0 0 0-.926-2.681l-5.243-.777-.035-.006-.005-.006-.013-.029-2.381-4.808A1.56 1.56 0 0 0 10.5.415",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const StarSolid = { render };
export {
  StarSolid as default,
  render
};
//# sourceMappingURL=StarSolid.svg.js.map
